export default "__VITE_ASSET__BOTnXcWm__"